import { useAuth } from './useAuth';

export const Legends = {
  ORGANIZACAO: { SINGULAR: 'Organização', PLURAL: 'Organizações' },
  CURSO: { SINGULAR: 'Curso', PLURAL: 'Cursos' },
  REITOR: { SINGULAR: 'Reitor', PLURAL: 'Reitores' },
  ESTUDANTE: { SINGULAR: 'Estudante', PLURAL: 'Estudantes' },
  GRUPO: { SINGULAR: 'Grupo', PLURAL: 'Grupos' },
  PROFESSOR: { SINGULAR: 'Professor', PLURAL: 'Professores' },
  LOCAL_ESTAGIO: {
    SINGULAR: 'Local de Estágio',
    PLURAL: 'Locais de Estágio',
  },
  COORDENADOR: { SINGULAR: 'Coordenador', PLURAL: 'Coordenadores' },
  PRECEPTOR: { SINGULAR: 'Preceptor', PLURAL: 'Preceptores' },
  SEMESTRE: { SINGULAR: 'Semestre', PLURAL: 'Semestres' },
  UNIDADE_CURRICULAR: {
    SINGULAR: 'Unidade Curricular',
    PLURAL: 'Unidades Curriculares',
  },
  PROFISSIONAL: { SINGULAR: 'Profissional', PLURAL: 'Profissionais' },
};

export type LegendsType = typeof Legends;

export const useLegends = () => {
  const { currentUser } = useAuth();
  const legends = currentUser?.activeProfile?.legends;

  const getLegends = (key: keyof LegendsType, isPlural?: boolean) => {
    if (legends?.[key] !== undefined) {
      return legends[key]?.[isPlural ? 'PLURAL' : 'SINGULAR'];
    } else {
      return Legends[key]?.[isPlural ? 'PLURAL' : 'SINGULAR'];
    }
  };

  return { getLegends };
};
